// eslint-disable-next-line caprikorn-rules/use-custom-translations
import { useTranslation } from "react-i18next";

import { CustomTranslation } from "./CustomTranslation/CustomTranslation";
import { useCustomTranslationContext } from "./CustomTranslation/CustomTranslation.context";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Translation = { key: any; params: any };

export const useCustomTranslation: typeof useTranslation =
  import.meta.env.VITE_APP_EDIT_TRANSLATION !== "true"
    ? useTranslation
    : (ns, options) => {
        const useTranslationReturn = useTranslation(ns, options);
        useCustomTranslationContext(); // Required to have immediate text update

        const customT: unknown = (
          key: Translation["key"],
          params: Translation["params"],
        ) => {
          if (!key) return undefined;
          const translation = useTranslationReturn.t(key, params) as string;
          return (
            <CustomTranslation
              key={translation}
              ns={params?.ns || (ns && (typeof ns === "string" ? ns : ns[0]))}
              params={params}
              translationKey={key}
            >
              {translation}
            </CustomTranslation>
          ) as never;
        };

        return {
          ...useTranslationReturn,
          // TODO force ns string only
          t: customT as typeof useTranslationReturn.t,
        };
      };
